module.exports = __webpack_public_path__ + "img/home-text.251b1403.png";